import React from 'react';
import { Shield, Award, Users, Target } from 'lucide-react';

const AboutUs = () => {
  const features = [
    {
      icon: <Shield className="w-10 h-10" />,
      title: 'Trusted Reviews',
      description: 'Every casino we feature undergoes rigorous testing for safety, fairness, and player experience.'
    },
    {
      icon: <Award className="w-10 h-10" />,
      title: 'Expert Analysis',
      description: 'Our team of gambling industry professionals brings years of experience to every review.'
    },
    {
      icon: <Users className="w-10 h-10" />,
      title: 'Player-Focused',
      description: 'We prioritize your interests, ensuring every recommendation serves your gaming needs first.'
    },
    {
      icon: <Target className="w-10 h-10" />,
      title: 'Latest Updates',
      description: 'Stay ahead with real-time bonus updates, new game releases, and industry insights.'
    }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-gradient-to-b from-white to-beige-50">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="inline-block px-4 py-2 glass rounded-full mb-6">
              <span className="text-brown-800 font-semibold">About Sterling Spins</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-brown-900 mb-6 leading-tight">
              Your Independent Guide to UK Online Casinos
            </h2>
            <div className="space-y-4 text-lg text-brown-700 leading-relaxed">
              <p>
                Sterling Spins stands as an independent review platform dedicated to helping UK players navigate the 
                online casino landscape. We cut through the marketing noise to deliver honest, actionable insights 
                that matter to real players.
              </p>
              <p>
                Our mission is simple: connect you with casinos that offer genuine value, secure gaming environments, 
                and rewarding experiences. We test every platform thoroughly, from game libraries to withdrawal speeds, 
                ensuring our recommendations meet the highest standards.
              </p>
              <p>
                Whether you're hunting for the best welcome bonuses, exploring new slot releases, or seeking trusted 
                operators with lightning-fast payouts, Sterling Spins is your starting point for smarter casino choices.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="glass-strong rounded-3xl p-8 overflow-hidden">
              <div className="aspect-square rounded-2xl relative overflow-hidden">
                <img 
                  src="/images/slnc-_68ATDXuBLo-unsplash.webp"
                  alt="Sterling Spins"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-brown-900/50 to-beige-900/50 flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-6xl font-bold text-white mb-2">2025</div>
                    <div className="text-beige-200 text-lg">Founded</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 glass rounded-full opacity-50"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="glass-strong rounded-2xl p-6 hover:scale-105 transition-transform duration-300">
              <div className="text-brown-700 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-brown-900 mb-3">{feature.title}</h3>
              <p className="text-brown-700 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

